import { render, staticRenderFns } from "./DebtInstallmentPagination.vue?vue&type=template&id=02303b88&scoped=true"
import script from "./DebtInstallmentPagination.vue?vue&type=script&lang=js"
export * from "./DebtInstallmentPagination.vue?vue&type=script&lang=js"
import style0 from "./DebtInstallmentPagination.vue?vue&type=style&index=0&id=02303b88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02303b88",
  null
  
)

export default component.exports